<script setup lang="ts">
import { computed } from "vue";
import type { HeadingLevel } from "@pixelpoint-pattern-library-v2/base/types";

type Props = {
  level: HeadingLevel;
  as?: "h" | "p" | "div" | "span";
};

const props = withDefaults(defineProps<Props>(), {
  as: "h",
});

const tag = computed(() => {
  if (props.as === "h") return `h${props.level}`;
  return props.as;
});
</script>

<template>
  <component :is="tag" class="h-pix-heading" :data-level="props.level" data-heading>
    <slot></slot>
  </component>
</template>
